(function ($) {
    // utility function go back to previous page
    $('.js__go-back').attr('href', 'javascript:history.go(-1)')
})(jQuery);